import React from 'react';
import { TableRow, TableCell, TableHead, TableSortLabel } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { makeStyles } from '@mui/styles';

const useStyles: any = makeStyles((theme: any) => ({
  tableCell: {
    color: theme.palette.grey[500],
    '& .Mui-active': {
      color: `${theme.palette.text.secondary[100]} !important`,
      '& .MuiTableSortLabel-icon': {
        color: `${theme.palette.text.secondary[100]} !important`
      }
    },
    '& .MuiTableSortLabel-icon': {
      fontSize: '20px !important'
    },
    width: '100%',
    whiteSpace: 'nowrap'
  },
  tableHeadText: {
    width: '100%'
  }
}));

export const EnhancedTableHead = props => {
  const classes = useStyles();
  const { order, orderBy, TABLE_HEAD, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {TABLE_HEAD?.map(column => {
          if (!column.hidden) {
            return (
              <TableCell
                key={column.id}
                sortDirection={orderBy === column.data ? order : false}
              >
                {column.sortable === false && (
                  <span className={classes.tableHeadText}>{column.label}</span>
                )}
                {/* the || below is to support the old usage and new column config usage */}
                {column.sortable !== false && (
                  <TableSortLabel
                    className={classes.tableCell}
                    onClick={createSortHandler(column.id)}
                    active={orderBy === column.id || orderBy === column.data}
                    direction={
                      orderBy === column.id || orderBy === column.data
                        ? order
                        : 'asc'
                    }
                    IconComponent={ArrowDropDownIcon}
                  >
                    <span className={classes.tableHeadText}>
                      {column.label}
                    </span>
                  </TableSortLabel>
                )}
              </TableCell>
            );
          }
        })}
      </TableRow>
    </TableHead>
  );
};
